<template>
  <sub-page :title="view === 'list' ? '个人就业见习岗位申请' : '我的见习申请'" @back="onPageBack">
    <div class="apply-page" v-if="view === 'list'">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="search-input">
          <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#999" stroke-width="2"/><path d="M16 16 L21 21" stroke="#999" stroke-width="2" stroke-linecap="round"/></svg>
          <input v-model="keyword" class="input" placeholder="请输入单位名称或岗位名称" />
        </div>
        <div class="city-select" @click="citySheetShow = true">
          <span>{{ city }}</span>
          <svg viewBox="0 0 24 24" class="city-arrow"><path d="M6 9 L12 15 L18 9" fill="none" stroke="#646566" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>

      <!-- 岗位列表 -->
      <div class="job-list">
        <div class="job-item" v-for="job in filteredList" :key="job.id">
          <div class="job-header">
            <span class="job-title">{{ job.title }}</span>
            <button
              :class="['apply-btn', { applied: appliedIds.indexOf(job.id) > -1 }]"
              @click="handleApply(job)"
            >{{ appliedIds.indexOf(job.id) > -1 ? '已报名' : '去报名' }}</button>
          </div>
          <div class="job-row">岗位发布日期：{{ job.publishDate }}</div>
          <div class="job-row">岗位截止日期：{{ job.deadline }}</div>
          <div class="job-row">单位名称：{{ job.company }}</div>
          <div class="job-row">见习期限：{{ job.duration }}</div>
          <div class="job-row">见习补贴：{{ job.subsidy }} 元/月</div>
        </div>
        <div class="empty-tip" v-if="filteredList.length === 0">未查询到符合条件的见习岗位</div>
      </div>

      <!-- 城市选择 -->
      <field-sheet
        :show="citySheetShow"
        title="请选择城市"
        :options="cityOptions"
        :value="city"
        @select="onCitySelect"
        @close="citySheetShow = false"
      />

      <!-- 我的申请悬浮按钮 -->
      <div class="float-btn" @click="view = 'mine'">我的申请</div>
    </div>

    <!-- 我的申请 -->
    <div class="apply-page" v-else>
      <div class="mine-list">
        <div class="mine-item" v-for="job in myApplyList" :key="job.id">
          <div class="mine-header">
            <span class="mine-title">{{ job.title }}</span>
            <span class="mine-status">{{ job.status }}</span>
          </div>
          <div class="mine-row">单位名称：{{ job.company }}</div>
          <div class="mine-row">报名时间：{{ job.applyTime }}</div>
          <div class="mine-row">见习期限：{{ job.duration }}</div>
        </div>
        <div class="empty-tip" v-if="myApplyList.length === 0">您还没有报名见习岗位</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import FieldSheet from '@/components/FieldSheet.vue'

export default {
  name: 'JobInternshipApply',
  components: { SubPage, FieldSheet },
  data() {
    return {
      view: 'list',
      keyword: '',
      city: '南京',
      citySheetShow: false,
      cityOptions: ['南京', '无锡', '徐州', '常州', '苏州', '南通', '连云港', '淮安', '盐城', '扬州', '镇江', '泰州', '宿迁'],
      jobList: [
        { id: 1, title: '软件开发见习岗', publishDate: '2026-09-01', deadline: '2026-10-31', company: '南京思柏瑞信息科技有限公司', duration: '6个月', subsidy: '2880' },
        { id: 2, title: '行政助理见习岗', publishDate: '2026-09-05', deadline: '2026-11-05', company: '南京惠众人力资源服务有限公司', duration: '3个月', subsidy: '2880' },
        { id: 3, title: '市场营销见习岗', publishDate: '2026-09-10', deadline: '2026-11-10', company: '中智江苏经济技术合作有限公司', duration: '6个月', subsidy: '2880' }
      ],
      appliedIds: [],
      applyTimeMap: {}
    }
  },
  computed: {
    filteredList() {
      const kw = this.keyword.trim()
      if (!kw) return this.jobList
      return this.jobList.filter(j => j.company.indexOf(kw) > -1 || j.title.indexOf(kw) > -1)
    },
    myApplyList() {
      return this.jobList
        .filter(j => this.appliedIds.indexOf(j.id) > -1)
        .map(j => Object.assign({}, j, { status: '待审核', applyTime: this.applyTimeMap[j.id] }))
    }
  },
  methods: {
    onCitySelect(val) {
      this.city = val
      this.citySheetShow = false
    },
    handleApply(job) {
      if (this.appliedIds.indexOf(job.id) > -1) {
        this.$alert('您已报名该岗位，报名信息正在审核中，请耐心等待')
        return
      }
      this.appliedIds.push(job.id)
      const now = new Date()
      const pad = n => (n < 10 ? '0' + n : '' + n)
      this.$set(this.applyTimeMap, job.id, `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`)
      this.$alert(`报名成功！您报名的「${job.title}」已提交至${job.company}，审核结果将在3个工作日内反馈，可在“我的申请”中查看进度`)
    },
    onPageBack() {
      if (this.view === 'mine') {
        this.view = 'list'
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped>
.apply-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.search-bar {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(20 * var(--w)) calc(24 * var(--w));
  gap: calc(20 * var(--w));
}
.search-input {
  flex: 1;
  height: calc(64 * var(--w));
  background: #f2f2f2;
  border-radius: calc(32 * var(--w));
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
  padding: 0 calc(24 * var(--w));
}
.search-icon {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: calc(26 * var(--w));
  color: #323233;
}
.input::placeholder {
  color: #c8c9cc;
}
.city-select {
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
  font-size: calc(28 * var(--w));
  color: #323233;
  flex-shrink: 0;
}
.city-arrow {
  width: calc(24 * var(--w));
  height: calc(24 * var(--w));
}
.job-list {
  margin-top: calc(16 * var(--w));
}
.job-item {
  background: #fff;
  padding: calc(24 * var(--w)) calc(32 * var(--w));
  margin-bottom: calc(16 * var(--w));
}
.job-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: calc(16 * var(--w));
}
.job-title {
  font-size: calc(32 * var(--w));
  font-weight: bold;
  color: #323233;
}
.apply-btn {
  background: #2E8CF6;
  color: #fff;
  font-size: calc(26 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  padding: calc(10 * var(--w)) calc(32 * var(--w));
  cursor: pointer;
  flex-shrink: 0;
}
.apply-btn.applied {
  background: #c8c9cc;
}
.job-row {
  font-size: calc(26 * var(--w));
  color: #646566;
  line-height: 1.8;
}
.empty-tip {
  text-align: center;
  color: #969799;
  font-size: calc(28 * var(--w));
  padding: calc(120 * var(--w)) 0;
}
.float-btn {
  position: fixed;
  right: calc(32 * var(--w));
  bottom: calc(80 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(26 * var(--w));
  padding: calc(16 * var(--w)) calc(28 * var(--w));
  border-radius: calc(40 * var(--w));
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(46, 140, 246, 0.4);
  cursor: pointer;
  z-index: 50;
}
.mine-list {
  padding: calc(20 * var(--w)) calc(24 * var(--w));
  display: flex;
  flex-direction: column;
  gap: calc(16 * var(--w));
}
.mine-item {
  background: #fff;
  border-radius: calc(12 * var(--w));
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.mine-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: calc(12 * var(--w));
}
.mine-title {
  font-size: calc(32 * var(--w));
  font-weight: bold;
  color: #323233;
}
.mine-status {
  font-size: calc(26 * var(--w));
  color: #ff976a;
  background: #FFF3EB;
  padding: calc(6 * var(--w)) calc(20 * var(--w));
  border-radius: calc(8 * var(--w));
}
.mine-row {
  font-size: calc(26 * var(--w));
  color: #646566;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/JobInternshipApply.vue